import { useContext } from "react";
import { LangContext } from '../../context/LangContext';
import Seo from "../../layouts/Seo";
import "./style.css";

function Terms({ page }) {
    const { translations } = useContext(LangContext);

    // Fonction pour formater le texte (mises en gras et sauts de ligne)
    const formatText = (text) => {
        if (!text) return null;

        // Divise le texte en lignes (pour gérer les \n)
        const lines = text.split('\n');

        return lines.map((line, lineIndex) => {
            // Divise chaque ligne en parties pour gérer **...**
            const parts = line.split(/\*\*(.*?)\*\*/);

            return (
                <span key={lineIndex}>
                    {parts.map((part, partIndex) =>
                        partIndex % 2 === 1 ? <strong key={partIndex}>{part}</strong> : part
                    )}
                    {lineIndex < lines.length - 1 && <br key={`br-${lineIndex}`} />}
                </span>
            );
        });
    };

    const pageConfig = {
        cgv: {
            articles: Array.from({ length: 12 }, (_, i) => i + 1),
            hasList: [3],
            hasExtraParagraphs: [],
        },
        copyright: {
            articles: Array.from({ length: 8 }, (_, i) => i + 1),
            hasList: [],
            hasExtraParagraphs: [],
        },
        cq: {
            articles: Array.from({ length: 3 }, (_, i) => i + 1),
            hasList: [],
            hasExtraParagraphs: [],
        },
        fanart: {
            articles: Array.from({ length: 5 }, (_, i) => i + 1),
            hasList: [2, 3, 5],
            hasExtraParagraphs: [2, 3, 5],
        },
        legacy: {
            articles: Array.from({ length: 11 }, (_, i) => i + 1),
            hasList: [5],
            hasExtraParagraphs: [5],
        },
        rgpd: {
            articles: Array.from({ length: 10 }, (_, i) => i + 1),
            hasList: [],
            hasExtraParagraphs: [],
        },
    };
    const config = pageConfig[page];

    const seoConfig = {
        cgv: {
            title: "Conditions Générales de Vente — VanRah Tegami Den",
            description: "Consultez les Conditions Générales de Vente de VanRah Tegami Den pour en savoir plus sur vos droits et obligations lors de l'achat d'œuvres ou de produits.",
        },
        copyright: {
            title: "Copyright — VanRah Tegami Den",
            description: "Informations sur les droits d'auteur et l'utilisation des œuvres de VanRah Tegami Den. Découvrez comment utiliser légalement les créations artistiques.",
        },
        cq: {
            title: "Questions Fréquentes — VanRah Tegami Den",
            description: "Réponses aux questions les plus fréquentes concernant VanRah Tegami Den, ses œuvres, et ses services.",
        },
        fanart: {
            title: "Fan Art — VanRah Tegami Den",
            description: "Découvrez les règles et conseils pour créer et partager des fan arts inspirés des œuvres de VanRah Tegami Den.",
        },
        legacy: {
            title: "Héritage — VanRah Tegami Den",
            description: "En savoir plus sur l'héritage et les œuvres antérieures de VanRah Tegami Den, ainsi que leur utilisation et leur conservation.",
        },
        rgpd: {
            title: "RGPD — VanRah Tegami Den",
            description: "Informations sur la protection des données personnelles chez VanRah Tegami Den, conformément au Règlement Général sur la Protection des Données (RGPD).",
        },
    };
    const { title, description } = seoConfig[page];


    // Fonction pour rendre une liste
    const renderList = (articleNum) => {
        const listItems = [];
        let i = 2;
        while (true) {
            const listItemKey = `${page}_art_${articleNum}_descrip_${i}`;
            if (!translations[listItemKey]) break;
            listItems.push(<li key={i}>{formatText(translations[listItemKey])}</li>);
            i++;
        }
        return listItems.length > 0 ? <ul>{listItems}</ul> : null;
    };

    // Fonction pour rendre les paragraphes supplémentaires
    const renderExtraParagraphs = (articleNum) => {
        const paragraphs = [];
        let i = 2;
        while (true) {
            const extraParagraphKey = `${page}_art_${articleNum}_descrip_${i}`;
            if (!translations[extraParagraphKey]) break;
            paragraphs.push(
                <p key={i} className="pre-line">{formatText(translations[extraParagraphKey])}</p>
            );
            i++;
        }
        return paragraphs;
    };

    return (
        <>
            <Seo
                title={title}
                description={description}
                type="website"
                image="https://vanrah-sama.com/og-terms.png"
                url={`https://vanrah-sama.com/${page}`}
            />
            <div className={`page page_terms page_${page}`}>
                <h2>{translations[`title_${page}`]}</h2>

                {config.articles.map((articleNum) => {
                    const labelKey = `${page}_art_${articleNum}_label`;
                    const descripKey = `${page}_art_${articleNum}_descrip`;

                    return (
                        <div key={articleNum}>
                            <h3>{translations[labelKey]}</h3>

                            {/* Paragraphe principal */}
                            {translations[descripKey] && (
                                <p className="pre-line">{formatText(translations[descripKey])}</p>
                            )}

                            {/* Paragraphes supplémentaires */}
                            {config.hasExtraParagraphs.includes(articleNum) &&
                                renderExtraParagraphs(articleNum)
                            }

                            {/* Liste si nécessaire */}
                            {config.hasList.includes(articleNum) &&
                                renderList(articleNum)
                            }
                        </div>
                    );
                })}
            </div>
        </>
    );
}

export default Terms;